export const domainTrackingMap = {
    'royalvape.com.cy': 'G-DB1JWZ5R5F',
    'www.royalvape.com.cy': 'G-DB1JWZ5R5F',
    'titosecig.com': 'G-PQ3ZTFSJQD', 
    'www.titosecig.com': 'G-PQ3ZTFSJQD', 
    'localhost' : '',
  };
  